import { isGeldigeIban, lijktOpTypfoutBtwNummer } from '@qc/core';
import { Knop } from '@qc/ui';
import { Veld } from '../auth/Veld.js';
import { useBedrijfsgegevens } from './useBedrijfsgegevens.js';

/**
 * De gegevens van Quality Cashless zelf.
 *
 * Ze komen op elke bon, elke factuur en in elk SEPA-bestand. Zolang ze niet
 * compleet zijn weigert de afrekening, dus dit scherm zegt dat er meteen bij
 * in plaats van pas op de dag van uitbetalen.
 */
export function Bedrijfsgegevens() {
  const beheer = useBedrijfsgegevens();

  if (beheer.laden) {
    return <p className="p-6 text-tekst-zacht">Bezig met laden…</p>;
  }

  const ibanFout = beheer.gegevens.iban !== '' && !isGeldigeIban(beheer.gegevens.iban);
  const btwWaarschuwing = lijktOpTypfoutBtwNummer(beheer.gegevens.btwNummer);

  return (
    <section className="rounded-tegel border border-rand bg-vlak p-6">
      <h2 className="mb-1 text-xl font-bold">Onze bedrijfsgegevens</h2>
      <p className="mb-4 text-tekst-zacht">
        Deze gegevens komen op elke bon, elke factuur en in het SEPA-bestand. Zolang ze niet
        compleet zijn kunnen we geen evenement afrekenen.
      </p>

      {beheer.ontbreekt.length > 0 && (
        <p className="mb-4 rounded-tegel bg-waarschuwing px-4 py-3 text-accent-tekst">
          Nog nodig: {beheer.ontbreekt.join(', ')}.
        </p>
      )}

      <div className="grid gap-4 sm:grid-cols-2">
        <Veld
          label="Bedrijfsnaam"
          value={beheer.gegevens.naam}
          onChange={(e) => beheer.zet({ naam: e.target.value })}
          fout={beheer.gegevens.naam.trim() === ''}
        />
        <Veld
          label="KvK-nummer"
          value={beheer.gegevens.kvkNummer}
          onChange={(e) => beheer.zet({ kvkNummer: e.target.value })}
          toelichting="Acht cijfers."
          inputMode="numeric"
        />
        <Veld
          label="BTW-nummer"
          value={beheer.gegevens.btwNummer}
          onChange={(e) => beheer.zet({ btwNummer: e.target.value })}
          toelichting={
            btwWaarschuwing
              ? 'Let op: dit nummer komt niet door de elfproef. Klopt het echt?'
              : 'Bijvoorbeeld NL123456782B01.'
          }
          autoCapitalize="characters"
        />
        <Veld
          label="IBAN"
          value={beheer.gegevens.iban}
          onChange={(e) => beheer.zet({ iban: e.target.value })}
          toelichting="Hiervandaan betalen we de kramen uit."
          fout={ibanFout}
          autoCapitalize="characters"
        />
        <Veld
          label="Adres"
          value={beheer.gegevens.adres}
          onChange={(e) => beheer.zet({ adres: e.target.value })}
        />
        <div className="grid grid-cols-[1fr_2fr] gap-3">
          <Veld
            label="Postcode"
            value={beheer.gegevens.postcode}
            onChange={(e) => beheer.zet({ postcode: e.target.value })}
          />
          <Veld
            label="Plaats"
            value={beheer.gegevens.plaats}
            onChange={(e) => beheer.zet({ plaats: e.target.value })}
          />
        </div>
        <Veld
          label="E-mail"
          value={beheer.gegevens.email}
          onChange={(e) => beheer.zet({ email: e.target.value })}
          type="email"
        />
        <Veld
          label="Telefoon"
          value={beheer.gegevens.telefoon}
          onChange={(e) => beheer.zet({ telefoon: e.target.value })}
          inputMode="tel"
        />
      </div>

      {beheer.fout !== null && <p className="mt-4 text-lg text-fout">{beheer.fout}</p>}
      {beheer.bewaard && <p className="mt-4 text-lg text-goed">Bewaard.</p>}

      <Knop
        nadruk="hoofd"
        className="mt-5"
        disabled={beheer.bezig || ibanFout}
        onClick={() => void beheer.bewaren()}
      >
        {beheer.bezig ? 'Bezig…' : 'Bewaren'}
      </Knop>
    </section>
  );
}
